export const AFFILIATE_LIST = [
    {
        utm_id: "babyface",
        utm_campaign: "20lastdiscount1",
        code: "20P_OFF_LAST_DISCOUNT",
        requires_no_referrer: true,
    }, {
        utm_id: "babyface",
        utm_campaign: "20lastdiscount2",
        code: "20P_OFF_LAST_DISCOUNT",
        requires_no_referrer: true,
    },
]